import React from "react";
import { InlineWidget } from "react-calendly";

const StrategicSessionBooking = () => {
  return (
    <div className=" mt-5">
      <div className="booking-card p-4 shadow rounded">
        <div className="text-center mb-4">
          <h6 className="text-muted">Schedule</h6>
          <h2 className="fw-bold">Free 30-min Strategic Session</h2>
          <p className="text-dark mb-1">🕒 30 min &nbsp; 💻 Web conferencing details upon confirmation</p>
          <p>This is your free strategic session with one of our experts via Calendly.</p>
        </div>

        <InlineWidget
          url="https://calendly.com/contact-dropshopi-now/30min"
          styles={{
            height: '700px',
          }}
        />
      </div>
    </div>
  );
};

export default StrategicSessionBooking;
